// extracted by mini-css-extract-plugin
export default {"sideNavAccordion":"SideNavAccordion_sideNavAccordion__J9kDx"};